import { render, staticRenderFns } from "./realPaySuccess.vue?vue&type=template&id=1e8c2a50&scoped=true&"
import script from "./realPaySuccess.vue?vue&type=script&lang=ts&"
export * from "./realPaySuccess.vue?vue&type=script&lang=ts&"
import style0 from "./realPaySuccess.vue?vue&type=style&index=0&id=1e8c2a50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8c2a50",
  null
  
)

export default component.exports